/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2025.12.6",
    versionName: "0.2.0-nightly.2025.12.6",
    versionChannel: "nightly",
    buildDate: "2025-12-06T00:07:27.881Z",
    commitHash: "3d28f99a3ec4fbaeb7215f2954ce73ce1cb67d94",
};
